// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__c9nf6","col":"styles_col__2vZ78"};